import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    PackageInfoDetails: []
  },
  getters: {
    PackageInfoDetails: state => state.PackageInfoDetails
  },
  actions: {
    searchCustomerByPhone({ commit, dispatch }, userName) {
      return new Promise((resolve, reject) => {
        ajax
          .get("IdentityAccess/api/UsersQuery/contains/" + userName)
          .then(r => {
            resolve(r.data);
          })
          .catch(e => {
            reject(e.response.data);
          });
      });
    },
    assignToOperator({ commit, dispatch }, model) {
      return ajax.put("Shipping/api/Packages/go-to-operator-assigned", model);
    },
    receiptImage({ commit, dispatch }, model) {
      return ajax.put("Shipping/api/Packages/receipt-image", model);
    },
    approvedToOperator({ commit, dispatch }, model) {
      return ajax.put("Shipping/api/Packages/go-to-operator-approved", model);
    },
    deliveryToCustomer({ commit, dispatch }, model) {
      return ajax.put("Shipping/api/Packages/go-to-delivered", model);
    },
    deliverdPackageFinish({ commit, dispatch }, model) {
      return ajax.put("Shipping/api/Packages/go-to-finished", model);
    },
    packageReject({ commit, dispatch }, model) {
      return ajax.put("Shipping/api/Packages/go-to-reject", model);
    },
    fetchPackageInfo({ commit }, id) {
      return new Promise((resolve, reject) => {
        ajax
          .get("Shipping/api/PackagesQuery/" + id)
          .then(r => {
            commit("setPackageInfoDetails", r.data);
            resolve(r.data);
          })
          .catch(e => reject(e));
      });
    }
  },
  mutations: {
    setPackageInfoDetails(state, data) {
      state.PackageInfoDetails = data;
    }
  }
};
